// vendor
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

// components
import Validation from '@/js/components/forms/validation';

gsap.registerPlugin(ScrollToPlugin);

class Service {
  constructor() {
    this.dom = {
      mapEl: document.getElementById('map'),
      formService: document.getElementById('form-service'),
      alertScroll: document.querySelector('.js-alert-scroll:not(.d-none)'),
    };

    this.props = {
      infoWindowContent: null,
    };

    this.components = {
      serviceFormValidation: null,
    };

    this.mount();
  }

  mount() {

    if (this.dom.formService) {
      this.components.serviceFormValidation = new Validation(this.dom.formService, true);
    }

    if (this.dom.alertScroll) {
      gsap.to(window, { duration: 0.5, scrollTo: this.dom.alertScroll, ease: 'power1' });
    }
  }

  /* eslint-disable class-methods-use-this */
  trackSuccessfullLead() {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'conversion', { send_to: 'AW-299216993/HIV6CMLUh_UCEOHg1o4B' });
    }
  }
}

if (document.getElementById('page-service')) {
  // eslint-disable-next-line no-new
  new Service();
}
